import React from 'react';
import { FaLinkSlash } from 'react-icons/fa6'; // Broken link icon
import { useNavigate } from 'react-router-dom';

// Utility class for the main neon glow effect (could be added to tailwind.config.js for reusability)
const neonGlow = 'shadow-[0_0_50px_#a29bfe] border-4 border-[#000] opacity-30';


const Error404PageTailwind = () => {

    const navigate = useNavigate()

    return (
        // Main Container: Dark background, full screen, centered content, and the neon border effect (simulated with relative/after)
        <div className="min-h-screen bg-[#181818] flex flex-col items-center justify-center p-6 text-white relative font-['Russo_One',sans-serif]">

            {/* Neon Border Effect Placeholder (You'd typically use actual CSS or a complex Tailwind config for the octagonal glow) */}
            <div className={`absolute inset-0 ${neonGlow} pointer-events-none`}></div>

            {/* Content Box */}
            <div className="text-center z-10 max-w-xl">

                {/* Logo/Title - Smaller Font */}
                <h1 className="text-xl md:text-2xl tracking-widest mb-6 uppercase">
                    BLACK<span className="font-extrabold">BATON</span>
                </h1>

                {/* 404 Text - Relatively smaller font for the large number */}
                <div className="text-9xl font-bold leading-none mb-4 md:mb-6">
                    404
                </div>

                {/* Circuit Board/Cracked Icon Placeholder (Simulated with a subtle gradient/shadow and positioning) */}
                <div className="relative w-40 h-10 mx-auto -mt-4 mb-8">
                    <div className="absolute inset-0 bg-black-600/10 rounded-full blur-xl animate-pulse"></div>
                    <div className="absolute inset-0 bg-gradient-to-r from-black-500/30 to-black-900/10 border-t border-black-500/50 shadow-inner shadow-black-500/20"></div>
                </div>

                {/* Page Not Found Text - Smaller font size */}
                <h2 className="text-lg md:text-xl tracking-[0.2em] uppercase flex items-center justify-center mb-10 -mt-8">
                    <FaLinkSlash className="text-2xl mr-3" />
                    PAGE NOT FOUND
                </h2>

                {/* Action Buttons */}
                <div className="flex justify-center gap-5">
                    {/* Go Home Button - Neon Blue Style */}
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-2 border-2 border-indigo-500 text-indigo-400 text-sm font-semibold uppercase tracking-wider 
                       bg-transparent hover:bg-indigo-600 hover:text-gray-900 transition duration-300 
                       hover:shadow-[0_0_15px_#6366f1]">
                        GO HOME
                    </button>

                    {/* <button
                        className="px-6 py-2 border-2 border-red-500 text-red-400 text-sm font-semibold uppercase tracking-wider 
                       bg-transparent hover:bg-red-600 hover:text-gray-900 transition duration-300 
                       hover:shadow-[0_0_15px_#ef4444]">
                        REPORT ERROR
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default Error404PageTailwind;